"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var stream_1 = require("stream");

var Console = function () {
  function Console(stdout) {
    if (stdout === void 0) {
      stdout = new stream_1.Duplex();
    }

    this.stdout = stdout;
  }

  Console.prototype.getStdout = function () {
    return this.stdout;
  };

  Console.prototype.on = function () {};

  return Console;
}();

exports.default = Console;